
import React from 'react';

const steps = [
  {
    number: 1,
    title: 'Take the Quiz',
    description: 'Answer a few quick questions about your loans, employment, and situation. Takes just 5 minutes.',
    color: 'bg-green-500',
  },
  {
    number: 2,
    title: 'We Prepare Everything',
    description: 'Our system automatically prepares applications for every program you qualify for. No complex decisions required.',
    color: 'bg-blue-600',
  },
  {
    number: 3,
    title: 'Submission & Review',
    description: 'We submit electronically where possible or provide a signed packet for you to mail. The Department of Education will then review your case and contact you directly.',
    color: 'bg-gradient-to-br from-green-400 to-blue-500',
  },
];

const StepCard: React.FC<{ step: typeof steps[0] }> = ({ step }) => (
    <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 flex flex-col items-start text-left h-full">
        <div className={`w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-xl mb-6 ${step.color}`}>
            {step.number}
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-2">{step.title}</h3>
        <p className="text-gray-600">{step.description}</p>
    </div>
);


const HowItWorks: React.FC = () => {
  return (
    <section className="py-16 sm:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
                <h2 className="text-4xl md:text-5xl font-extrabold tracking-tight text-gray-900">
                How It Works
                </h2>
                <p className="mt-4 max-w-2xl mx-auto text-lg md:text-xl text-gray-600">
                Three simple steps to loan forgiveness
                </p>
            </div>

            <div className="mt-16 grid grid-cols-1 gap-8 md:grid-cols-3">
                {steps.map((step) => (
                    <StepCard key={step.number} step={step} />
                ))}
            </div>
        </div>
    </section>
  );
};

export default HowItWorks;
